<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h3 class="headline mb-0">Kategorien</h3>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex :key="category.id" xs12 md6 lg4 xl4 v-for="category in categories" class="mb-2">
          <v-card :class="getCategoryClass(category)" :flat="isCategoryFinished(category)">
            <v-card-title primary-title>
              <h3 class="subheadline mb-0">{{ category.title}}</h3>
              <CategoryStatus :category="category"></CategoryStatus>
            </v-card-title>
            <v-card-text>
              <v-layout row>
                <v-flex xs12>
                  <p>Versorgungspunkte: {{ category.checkpoints.length }}</p>
                  <p>Startnummernbereich: <span v-if="category.startNumberMin !== null || category.startNumberMax !== null">{{ category.startNumberMin }} bis {{ category.startNumberMax }}</span></p>
                </v-flex>
              </v-layout>
              <v-list>
                <v-subheader>Teilnehmer</v-subheader>
                <v-list-group>
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-chip color="success">{{ getParticipantsFromCategory(category, true).length }}</v-chip>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-if="category.startTime !== null">Unterwegs</v-list-tile-title>
                        <v-list-tile-title v-else>Anwesend</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>

                  <v-list-tile v-for="participant in getParticipantsFromCategory(category, true)" :key="participant.id">
                    <v-list-tile-avatar>
                      <ParticipantStatus :participant="participant"></ParticipantStatus>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ participant.firstname }} {{ participant.lastname }}</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn icon :to="{name: 'participant', params: {id: participant.id}}"><v-icon>fal fa-user</v-icon></v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list-group>

                <v-list-group>
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-chip color="error">{{ getParticipantsFromCategory(category, false).length }}</v-chip>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Abwesend</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>

                  <v-list-tile v-for="participant in getParticipantsFromCategory(category, false)" :key="participant.id">
                    <v-list-tile-avatar>
                      <ParticipantStatus :participant="participant"></ParticipantStatus>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ participant.firstname }} {{ participant.lastname }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-btn v-if="isCategoryFinished(category) === true" color="success" @click="stopCategory(category)">Beendet</v-btn>
              <v-btn v-else-if="category.startTime !== null" color="success" @click="stopCategory(category)"><v-icon left small>fal fa-stopwatch</v-icon> {{ category.startTime.substr(0, category.startTime.length - 3) }}</v-btn>
              <v-btn v-else color="error" @click="startCategory(category)"><v-icon>fal fa-stopwatch</v-icon></v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="category.startTime === null" :to="{name: 'category', params: { id: category.id }}"><v-icon>fal fa-edit</v-icon></v-btn>
              <v-spacer></v-spacer>
              <vue-json-to-csv
                  :csv-title="getCategory(category.id).title"
                  :json-data="getParticipantsByCategoryId(category.id)"
                  :labels="csvLabels"
              >
                <v-btn>CSV</v-btn>
              </vue-json-to-csv>
              <v-btn @click="generatePdf(category.id)">PDF</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import jsPDF from 'jspdf'
  import 'jspdf-autotable';
  import VueJsonToCsv from 'vue-json-to-csv'
  import ParticipantStatus from "../components/ParticipantStatus";
  import CategoryStatus from "../components/CategoryStatus";

  export default {
    components: {
      CategoryStatus,
      ParticipantStatus,
      VueJsonToCsv
    },
    computed: {
      event() {
        return this.$store.state.event
      },
      categories() {
        return this.$store.state.categories
      },
      participants() {
        return this.$store.state.participants
      }
    },
    data: function () {
      return {
        csvLabels: {
          id: {title: 'ID'},
          firstname: {title: 'Vorname'},
          lastname: {title: 'Nachname'},
          email: {title: 'E-Mail'},
          street: {title: 'Straße'},
          postal: {title: 'Postleitzahl'},
          city: {title: 'Ort'},
          country: {title: 'Land'},
          phone: {title: 'Telefon'},
          shirt:{ title: 'T-Shirt' },
        },
        participantsToShow: 'all'
      }
    },
    methods: {
      getParticipantsFromCategory (category, presence) {
        if (presence === true) {
          let participants = this.participants.filter(participant => participant.category === category.id && participant.startNumber !== null)
          participants.sort((a, b) => {
            if (a.timeEntries.length < b.timeEntries.length) {
              return 1
            } else if (a.timeEntries.length > b.timeEntries.length) {
              return -1
            }
            return 0
          })
          return participants
        }
        return this.participants.filter(participant => participant.category === category.id && participant.startNumber === null)
      },
      getParticipantsByCategoryId (categoryId) {
        let participants = this.participants.filter(item => item.category === categoryId)
        if (participants !== undefined) {
          participants.map(participant => {
            if (participant.startNumber === null) {
              participant.startNumberDisplay = ''
            } else {
              participant.startNumberDisplay = participant.startNumber
            }

            if (participant.canceled === true) {
              participant.description = 'Teilnahme abgesagt'
            } else if (participant.startNumber === null) {
              participant.description = 'Nicht angetreten'
            }

            return participant
          })

          return [...participants].sort(function (a, b) {
            return a.startNumber - b.startNumber
          });
        }
      },
      getCategory: function (categoryId) {
        return this.categories.find(item => item.id === categoryId)
      },
      generatePdf: function (categoryId) {
        const eventTitle = this.event.title
        let category = this.getCategory(categoryId)
        let columns = [
          {title: 'Startnummer', dataKey: 'startNumberDisplay'},
          {title: 'Vorname', dataKey: 'firstname'},
          {title: 'Nachnahme', dataKey: 'lastname'},
          {title: 'Bemerkungen', dataKey: 'description'}
        ]
        let doc = new jsPDF()
        doc.autoTable(columns, this.getParticipantsByCategoryId(categoryId), {
          margin: {top: 25},
          addPageContent: function () {
            doc.text(eventTitle + ' - ' + category.title, 15, 15)
          },
          headerStyles: {
            fillColor: [46, 126, 51]
          }
        })

        let pageCount = doc.internal.getNumberOfPages();
        let date = new Date()
        for (let page = 0; page < pageCount; page++) {
          doc.setPage(page);
          doc.setFontSize(8)
          doc.text(10, 290, 'drussen.de - ' + date.toLocaleDateString('de-DE') + ' ' + date.toLocaleTimeString('de-DE'))
          doc.text(180, 290, 'Seite ' + (page + 1) + ' von ' + pageCount)
        }
        window.open(doc.output('bloburi'));
        //doc.save(category.title + '.pdf')
      },
      getCategoryClass (category) {
        if (this.isCategoryFinished(category) === true) {
          return 'finished'
        } else if (category.startTime !== null) {
          return 'running'
        }
      },
      startCategory (category) {
        const date = new Date()
        category.startTime = this.displayDateGerman(date);
        this.$store.dispatch('updateCategory', category)
      },
      stopCategory (category) {
        this.$confirm('Soll die Kategorie "' + category.title + '" wirklich gestoppt werden werden? Bereits registrierte Zwischenzeiten der Teilnehmer gehen verloren.').then(res => {
          if (res) {
            category.startTime = null;
            this.$store.dispatch('updateCategory', category)
          }
        })
      },
      isCategoryFinished (category) {
        let participants = this.participants.filter(participant => participant.category === category.id)
        let max = participants.length
        if (max === 0) return  false
        let ready = 0;
        participants.forEach(participant => {
          if (participant.canceled === true) {
            ready++
          } else if(participant.progress === category.checkpoints.length && category.checkpoints.length > 0) {
            ready++
          }
        })

        return ready === max
      },
    }
  }
</script>

<style lang="scss" scoped>
  .v-card {
    /*
    display: flex;
    justify-content: space-between;
    flex-direction: column;
*/
    &.finished {
      border: 1px solid green;
    }

    &.running {
      bordeR: 1px solid orange;
    }
  }
</style>
